import "./userDetail.css";
import { AES, enc } from "crypto-js";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import userTypeName from "../../../constants/userType.js";
import { setHeaderText } from "../../../features/headerText/headerTextSlice.js";
import UserProfile from "../../../components/User/UserDetails/UserProfile/UserProfile.jsx";
import UserAccount from "../../../components/User/UserDetails/UserAccount/UserAccount.jsx";
import { resetAccountDetails } from "../../../features/accountDetails/accountDetailsSlice.js";
import UserTeam from "../../../components/User/UserDetails/UserNotification/UserTeam.jsx";

function UserDeatils() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const { encryptedId } = useParams();

  // Add safety checks for ID decryption
  let id = null;
  if (encryptedId) {
    try {
      const decodedId = decodeURIComponent(encryptedId.replace(/%2F/g, "/"));
      const decryptedBytes = AES.decrypt(decodedId, "encryptionKey");
      id = decryptedBytes.toString(enc.Utf8);
    } catch (error) {
      console.error("Error decrypting ID:", error);
      console.log("Encrypted ID:", encryptedId);
    }
  } else {
    console.error("No encryptedId found in URL parameters");
  }
  const accountDetails = useSelector(
    (state) => state.accountDetails.accountDetails
  );
  const userRole = useSelector((state) => state.user);

  const handleTabClick = (index) => {
    try {
      setActiveTab(index);
      dispatch(resetAccountDetails());
      localStorage.setItem("activeTab", String(index));
    } catch (error) {
      console.error("Error in handleTabClick:", error);
    }
  };

  const allAccount = () => {
    try {
      dispatch(resetAccountDetails());
    } catch (error) {
      console.error("Error in allAccount:", error);
    }
  };

  useEffect(() => {
    try {
      const storedActiveTab = localStorage.getItem("activeTab");
      if (storedActiveTab) {
        setActiveTab(Number(storedActiveTab));
      }
      dispatch(setHeaderText("My Team"));
    } catch (error) {
      console.error("Error in useEffect (localStorage/dispatch):", error);
    }
  }, [id, dispatch]);

  useEffect(() => {
    try {
      // Only set default tab if no stored value exists
      const storedActiveTab = localStorage.getItem("activeTab");
      if (!storedActiveTab) {
        setActiveTab(0);
      }
    } catch (error) {
      console.error("Error in initial tab set:", error);
    }
  }, []);

  // Check for URL parameter to automatically open bank account tab
  const [shouldOpenBankModal, setShouldOpenBankModal] = useState(false);

  useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('openBankAccount') === 'true') {
        // Set the active tab to bank accounts (tab 1)
        localStorage.setItem('activeTab', '1');
        setActiveTab(1);
        // Trigger bank modal opening
        setShouldOpenBankModal(true);
      }
    } catch (error) {
      console.error("Error in bank account tab activation:", error);
    }
  }, []);

  return (
    <div className="content-inner-inner user-profile-page-wrapper">
      {accountDetails === false ? (
        <div className="back-to user-profile-back-to">
          <Link to="/user/myteam/list">
            Back to All Users
          </Link>
        </div>
      ) : (
        <div className="back-to user-profile-back-to">
          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault();
              allAccount();
            }}
          >
            Back to All Accounts
          </Link>
        </div>
      )}

      <div className="tab-outer">
        <ul className="tabs">
          <li
            className={activeTab === 0 ? "active-tab" : ""}
            onClick={() => handleTabClick(0)}
          >
            Profile
          </li>

          <li
            className={activeTab === 1 ? "active-tab" : ""}
            onClick={() => handleTabClick(1)}
          >
            <>Bank Accounts</>
          </li>

          {userRole.userRolename === userTypeName.Team_Manager && (
            <li
              className={activeTab === 3 ? "active-tab" : ""}
              onClick={() => handleTabClick(3)}
            >
              Team
            </li>
          )}
        </ul>

        <div className="tabs-content">
          <div style={{ display: activeTab === 0 ? "block" : "none" }}>
            {id ? (
              <UserProfile id={id} />
            ) : (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <p>Error: Invalid user ID. Please check the URL or try again.</p>
                <p>Encrypted ID: {encryptedId || 'Not found'}</p>
              </div>
            )}
          </div>
          <div style={{ display: activeTab === 1 ? "block" : "none" }}>
            {id ? (
              <UserAccount id={id} shouldOpenBankModal={shouldOpenBankModal} onModalOpened={() => setShouldOpenBankModal(false)} isActive={activeTab === 1} />
            ) : (
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <p>Error: Invalid user ID. Please check the URL or try again.</p>
                <p>Encrypted ID: {encryptedId || 'Not found'}</p>
              </div>
            )}
          </div>
          {userRole.userRolename === userTypeName.Team_Manager && (
            <div style={{ display: activeTab === 3 ? "block" : "none" }}>
              <UserTeam id={id} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UserDeatils;
